import { Component, OnInit, ViewChild } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { BcledgerService } from "../../../../../core/services/bcledger.service";
import { UserManagementService } from "../../../../../core/services/user-management.service";
import { ReportsService } from "../../../../../core/services/reports.service";
import { RptClientListingComponent } from "../rpt-client-listing/rpt-client-listing.component";
import { JniToastrService } from "../../../../../core/services/jni-toastr.service";
import { GenericResponseDto } from "../../../../../core/models/generic-response.dto";
import { BCLedgerTopClientDataDto } from "../../../../../core/models/reports/bcLedgerTopClientDataDto";
import { BCLedgerTopClientRptExcelRequestDto } from "../../../../../core/models/reports/bcLedgerTopClientRptExcelRequestDto";
import { BCLedgerTopClientRptRequestDto } from "../../../../../core/models/reports/bcLedgerTopClientRptRequestDto";
import { RptClientFilterComponent } from "../rpt-client-filter/rpt-client-filter.component";
import { Employee } from "../../../../../core/models/profile/employee";
import { ValidateLogin } from "../../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../../core/services/loader.service";
import { CommonModule } from "@angular/common";

@UntilDestroy()
@Component({
  selector: "jni-rpt-client-report",
  templateUrl: "./rpt-client-report.component.html",
  styleUrls: ["./rpt-client-report.component.scss"],
  imports: [RptClientListingComponent, RptClientFilterComponent, CommonModule],
})
export class RptClientReportComponent implements OnInit {
  constructor(
    private _userManagement: UserManagementService,
    private _bcledgerService: BcledgerService,
    private _loader: LoaderService,
    private _reportService: ReportsService,
    private _toastr: JniToastrService
  ) {}

  current = new Date().toISOString();
  userStatus = "";
  bcList: Employee[] = [];
  reportFilter: BCLedgerTopClientRptRequestDto =
    {} as BCLedgerTopClientRptRequestDto;
  reportData: BCLedgerTopClientDataDto[] = [];
  dateRange = "";

  @ViewChild("listing", { static: false })
  listing!: RptClientListingComponent;

  ngOnInit(): void {
    this.getAllEmployee();
    this.getBcUser();
  }

  getAllEmployee() {
    this._userManagement
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userStatus = res.data.userRole;
      });
  }

  getBcUser() {
    this._bcledgerService
      .getAllEmployees()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<Employee[]>) => {
          this.bcList = res.data;
        },
      });
  }

  getRptClientFormData(
    rptClientReportRequestFilter: BCLedgerTopClientRptRequestDto
  ) {
    this._loader.setLoaderState(true);
    this.reportFilter = { ...rptClientReportRequestFilter };

    const requestPayload: BCLedgerTopClientRptRequestDto = {
      BrandingConsultantID:
        rptClientReportRequestFilter.BrandingConsultantID || "",
      FromDate: rptClientReportRequestFilter.FromDate || "",
      ToDate: rptClientReportRequestFilter.ToDate || "",
      DateRange: rptClientReportRequestFilter.DateRange || "",
    };

    this._reportService.getRptClientReport(requestPayload).subscribe({
      next: res => {
        if (res?.Data && res?.Message.toLowerCase() === "success") {
          if (res?.Data.length > 0) {
            this.reportData = res?.Data;
            this.dateRange = rptClientReportRequestFilter.DateRange;
            this.listing.setMainFilter(
              rptClientReportRequestFilter.FromDate,
              rptClientReportRequestFilter.ToDate
            );
          } else {
            this._toastr.error("RPT Top Client Report", "No record found");
          }
          this._loader.setLoaderState(false);
        }
      },
      error: () => {
        this._loader.setLoaderState(false);
        this._toastr.error(
          "RPT Top Client Report",
          "Error in Fetching RPT Client Report API"
        );
      },
    });
  }

  getExcelReport(event: {
    clientName: string;
    clientAcct: string;
    sortField: string;
    sortOrder: number;
  }) {
    this._loader.setLoaderState(true);

    const requestPayload: BCLedgerTopClientRptExcelRequestDto = {
      BrandingConsultantID: this.reportFilter.BrandingConsultantID || "",
      FromDate: this.reportFilter.FromDate || "",
      ToDate: this.reportFilter.ToDate || "",
      DateRange: this.reportFilter.DateRange || "",
      ClientName: event.clientName || "",
      ClientAcct: event.clientAcct || "",
      SortOrder: event.sortOrder,
      SortField: event.sortField,
    };

    this._reportService.getRptClientExcelReport(requestPayload).subscribe({
      next: res => {
        if (res?.data && res?.message.toLowerCase() === "success") {
          if (res?.data.length > 0) {
            const binaryData = atob(res.data);

            const blob = new Blob(
              [
                new Uint8Array(binaryData.length).map((_, index) =>
                  binaryData.charCodeAt(index)
                ),
              ],
              {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }
            );

            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);

            // Create a link element to trigger the download
            const a = document.createElement("a");
            a.href = url;
            a.download = "RPT Top Client Report.xlsx";
            a.click();

            // Revoke the object URL to free up resources
            window.URL.revokeObjectURL(url);
          } else {
            this._toastr.error("RPT Top Client Report", "No record found");
          }
          this._loader.setLoaderState(false);
        }
      },
      error: () => {
        this._loader.setLoaderState(false);
        this._toastr.error(
          "RPT Top Client Report",
          "Error in Fetching RPT Client Report API"
        );
      },
    });
  }
}
